import { SealCheck } from '@phosphor-icons/react';
import { t } from 'i18next';

import { FlexBox, Tooltip } from 'core/elements';
import { QuotePartHelper } from 'quotes/helpers';
import { ICustomerQuotePart } from 'quotes/types';
import { Color } from 'theme/enums';

interface IProps {
  quotePart?: ICustomerQuotePart;
}

export const PrioritizeLegacyCostTooltip = ({ quotePart }: IProps) => {
  if (!QuotePartHelper.isPrioritizingLegacyCost(quotePart)) {
    return null;
  }

  return (
    <Tooltip title={t('messagePrioritizeLegacyCostOn')} color={Color.PRIMARY} placement="top">
      <FlexBox sx={{ color: 'primary.500', fontSize: 16 }}>
        <SealCheck weight="regular" />
      </FlexBox>
    </Tooltip>
  );
};
